<div *ngIf="borrowerStatus$ | async as borrowerStatus">
  <div *ngIf="(complianceReview$ | async); else elseBlock">
    <!-- fake mat-select button to mimic borrower status picker -->
    <button mat-stroked-button>
      <span class="tw-rounded-full tw-bg-black tw-inline-block tw-w-3 tw-h-3 tw-mr-3" [style.backgroundColor]="$red-300"></span>
      <strong class="tw-mr-3">Compliance Review</strong>
    </button>
  </div>
  <ng-template #elseBlock>

    <!-- EDITING: DROPDOWN / CHANGE STATUS BUTTON -->
    <div *ngIf="mode === 'editable' else display">

      <div *ngIf="(canUseNewBorrowerStatusModal$ | async); else oldStatusPicker">
        <button
          mat-stroked-button
          *ngIf="borrowerStatus"
          [disabled]="borrowerStatus.status === 'doNotContact'"
          (click)="changeBorrowerStatus()"
        >
          <span class="tw-rounded-full tw-bg-black tw-inline-block tw-w-3 tw-h-3 tw-mr-3" [style.backgroundColor]="stageColors[borrowerStatus.borrower_stage_lookup.stage]"></span>
          <span class="tw-mr-4 tw-text-gray-400">{{ borrowerStatus.label }}</span>
          <span *ngIf="borrowerStatus.status !== 'doNotContact'" interactive>Change Status</span>
        </button>
      </div>

      <ng-template #oldStatusPicker>
        <app-borrower-status-picker-smart></app-borrower-status-picker-smart>
      </ng-template>

    </div>

    <ng-template #display>
      <div class="tw-rounded tw-border tw-border-gray-400 tw-p-2 tw-grid tw-grid-flow-col tw-items-center">
        <span class="tw-rounded-full tw-bg-black tw-block tw-w-3 tw-h-3 tw-mr-2" [style.backgroundColor]="stageColors[borrowerStatus.borrower_stage_lookup.stage]"></span>
        <span class="tw-text-gray-400">{{ borrowerStatus.label }}</span>
      </div>
    </ng-template>

  </ng-template>
</div>

